import { render, staticRenderFns } from "./jyhzbm.vue?vue&type=template&id=94f3fd72&scoped=true"
import script from "./jyhzbm.vue?vue&type=script&lang=js"
export * from "./jyhzbm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f3fd72",
  null
  
)

export default component.exports